import React, { FC, PropsWithChildren } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

// models
import { SMSPreviewModel } from '../../../../models/editor.model';

const SmsPreview: FC<PropsWithChildren<SMSPreviewModel>> = ({
    id,
    content,
    isSkeleton,
}) => {
    return (
        <Message key={id}>
            <Body isSkeleton={isSkeleton}>{content.message}</Body>
        </Message>
    );
};

export default SmsPreview;

const Message = styled.div({
    background:
        'linear-gradient(279deg, #F2F7FC 1.91%, #F9FBFE 16.23%, #FFF 39.11%)',
    boxShadow: '0px 4px 6px 2px rgba(13, 99, 184, 0.08)',
    borderRadius: aampeTheme.borderRadius.message,
    border: `1px solid ${aampeTheme.colors.white}`,
    padding: aampeTheme.spacing4(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '242px',
    height: 'fit-content',
    whiteSpace: 'pre-wrap',
    gap: aampeTheme.spacing4(3),
});

const Body = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isSkeleton',
})<{ isSkeleton?: boolean }>(({ isSkeleton }) => ({
    color: isSkeleton ? 'transparent' : aampeTheme.colors.neutral09,
    fontSize: aampeTheme.size.font.textSmall,
    lineHeight: aampeTheme.size.lineHeight.small,
    wordBreak: 'break-word',
    display: 'inline-block',
    fontWeight: isSkeleton ? 600 : 400,
    textShadow: isSkeleton
        ? `0 0 4px ${aampeTheme.colors.interactiveWG01}`
        : 'none',
}));
